import Vuex from "vuex"
import Vue from "vue"
import axios from "axios"
Vue.use(Vuex)
const store = new Vuex.Store({
    state: {
      haslogin:false,
      usertoken:null,
      username:'',
      password:'',
      userid:'',
      //首页显示标签option
      shows:false,
      indexx:'',
      id:'',
      token:'',
      squeeze_out:false,
    },
    mutations: {
      changehaslogin () {
        this.state.haslogin=!this.state.haslogin;
      },
      chanshowtag(vm,n){
        vm.shows=!vm.shows
      },
      chantoken(res,n){
       // alert('改变token');
       // alert(JSON.stringify(n));
        this.state.usertoken=n;
      },
      chanid(res,n){
        res.userid=n;
      },
      inituser(){
        //这里赋值 和 清空
        var token=localStorage.purebaby_token?localStorage.purebaby_token:'';
        axios.defaults.headers.common['Authorization']=store.state.token=token;
        if(store.state.token) store.state.haslogin=true;
        store.state.username=localStorage.purebaby_username?localStorage.purebaby_username:'';
        store.state.password=localStorage.purebaby_password?localStorage.purebaby_password:'';
        store.state.userid=store.state.id=localStorage.purebaby_userid?localStorage.purebaby_userid:'';
      },
      logout(){
        localStorage.purebaby_token='';
        localStorage.purebaby_username='';
        localStorage.purebaby_password='';
        localStorage.purebaby_userid='';
        store.state.haslogin=false;
        store.commit("inituser");
      }
    }
  });
  //判断是否local有缓存  如果有pure_token 那么就读取
  // if(localStorage.purebaby_token) {
  //   store.state.token=localStorage.purebaby_token;
  //   store.state.haslogin=true;
  //   axios.defaults.headers.common['Authorization'] = localStorage.purebaby_token;
  // };
  // if(localStorage.purebaby_username) store.state.username=localStorage.purebaby_username;
  // if(localStorage.purebaby_password) store.state.username=localStorage.purebaby_password;
  //初始化
  store.commit("inituser");


  export default store;


// WEBPACK FOOTER //
// ./src/store/user.js